var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 4,
    viewBox: "0 0 20 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.88802 3.33463C1.51024 3.33463 1.19358 3.20686 0.938021 2.9513C0.682465 2.69575 0.554688 2.37908 0.554688 2.0013C0.554688 1.62352 0.682465 1.30686 0.938021 1.0513C1.19358 0.795746 1.51024 0.667969 1.88802 0.667969H17.888C18.2658 0.667969 18.5825 0.795746 18.838 1.0513C19.0936 1.30686 19.2214 1.62352 19.2214 2.0013C19.2214 2.37908 19.0936 2.69575 18.838 2.9513C18.5825 3.20686 18.2658 3.33463 17.888 3.33463H1.88802Z",
    fill: "#63637D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.abbff074b84e35af5b9e7bd0f1b08dca.svg";
export { ForwardRef as ReactComponent };